// extracted by mini-css-extract-plugin
module.exports = {"efmodal":"PointsModal_efmodal__eH9bZ"};